import { useEffect } from 'react';

const locks = new WeakMap();

export default function useBodyScrollLock(active = true) {
  useEffect(() => {
    if (!active) return;
    const body = document.body;
    const lock = locks.get(body) || { count: 0, previousOverflow: body.style.overflow };
    lock.count += 1;
    locks.set(body, lock);
    body.style.overflow = 'hidden';
    return () => {
      lock.count -= 1;
      if (lock.count === 0) {
        body.style.overflow = lock.previousOverflow;
        locks.delete(body);
      }
    };
  }, [active]);
}
